<template>
  <div class="header">
    <div class="header__left">
      <div>
        <profile-menu class="header__avatar" :avatarUrl="avatarUrl" :showForumLink="showForumLink" />
      </div>
      <div>
        <share-menu />
      </div>
    </div>
    <div class="header__center">
      <visualiser-logo />
    </div>
    <div class="header__right">
      <badge class="header__badge" text="BETA" />
    </div>
  </div>
</template>
<script setup lang="ts">
import ProfileMenu from '@/components/nav/ProfileMenu.vue'
import ShareMenu from '@/components/nav/ShareMenu.vue'
import { useEndUserProfileStore } from '@/store/user-profile'
import { computed } from 'vue'
import VisualiserLogo from '@/assets/VisualiserLogo.svg'
import Badge from '@/components/nav/Badge.vue'

const endUserProfileStore = useEndUserProfileStore()

const props = defineProps<{
  showForumLink: boolean
}>()

const avatarUrl = computed(() => endUserProfileStore.avatar ?? 'https://static.serato.com/common/images/default-profile-picture.svg')
</script>
<style lang="scss">
.header {
  background: $grey-90;
  position: relative;
  font-family: $font-light;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: auto;
  height: 64px;
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: row;
  padding: 12px 16px 12px 24px;

  &__left {
    display: flex;
    flex-basis: 50%;

    >div {
      padding-right: 20px;
      padding-left: 19px;
      border-right: 1px solid $grey-80;

      &:last-child {
        border-right: none;
      }

      &:first-child {
        padding-left: 0px;
      }
    }
  }

  &__right {
    height: 100%;
    display: flex;
    flex-basis: 50%;
    justify-content: flex-end;
  }

  &__avatar {
    width: 55px;
  }

  &__fade {
    &-enter-active {
      transition: opacity 400ms $animationCurve;
    }

    &-enter-from {
      opacity: 0;
    }
  }
}
</style>
